export default __webpack_public_path__ + "static/media/restaurants.b0f0798b.png";